<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="d-flex justify-space-between">
      <template v-slot:default="{ open }">
        <span class="font-weight-medium text-h6">{{ secaoDataLocale.titulo }}</span>
        <div
          v-if="open"
          class="d-flex justify-end mr-2"
        >
          <configurar-secao-dialog
            :is-configurar-secao-dialog-open.sync="isConfigurarSecaoDialogOpen"
            :secao-data="secaoDataLocale"
            @refetch-data="getSecao"
          >
          </configurar-secao-dialog>

          <v-icon
            class="ml-2"
            color="primary"
            @click.native.stop="isConfigurarSecaoDialogOpen = !isConfigurarSecaoDialogOpen"
          >
            {{ icons.mdiCog }}
          </v-icon>

          <deletar-secao-dialog
            :is-deletar-secao-dialog-open.sync="isDeletarSecaoDialogOpen"
            :secao-id="secaoDataLocale.id"
            @secao-removida="$emit('secao-removida')"
          >
          </deletar-secao-dialog>

          <v-icon
            class="ml-2"
            color="error"
            @click.native.stop="isDeletarSecaoDialogOpen = !isDeletarSecaoDialogOpen"
          >
            {{ icons.mdiDelete }}
          </v-icon>
        </div>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <tabela-de-celulas
        :secao-data="secaoDataLocale"
        @refetch-data="getSecao"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mdiCog, mdiDelete } from '@mdi/js'
import { ref, reactive } from '@vue/composition-api'
import ConfigurarSecaoDialog from './ConfigurarSecaoDialog.vue'
import TabelaDeCelulas from '../celulas/TabelaDeCelulas.vue'
import DeletarSecaoDialog from './DeletarSecaoDialog.vue'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    TabelaDeCelulas,
    ConfigurarSecaoDialog,
    DeletarSecaoDialog,
  },

  props: {
    secaoData: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const isConfigurarSecaoDialogOpen = ref(false)
    const isDeletarSecaoDialogOpen = ref(false)
    const secaoDataLocale = reactive(props.secaoData)

    const getSecao = async () => {
      const data = await FormularioService.getSecao(secaoDataLocale.idFormulario, secaoDataLocale.id)

      Object.assign(secaoDataLocale, data)
    }

    return {
      isConfigurarSecaoDialogOpen,
      isDeletarSecaoDialogOpen,
      secaoDataLocale,
      getSecao,
      icons: {
        mdiCog,
        mdiDelete,
      },
    }
  },
}
</script>
